import { useEffect, useMemo } from "react";

import { bannerStorage } from "storage/banner";
import { useStoredState } from "storage/state";

const useDailyBanner = (
  bannerName: string,
  userEmail: string,
  bannerClosedDate: string | null,
): boolean => {
  const [, setStoredDate] = useStoredState(
    `banner_show-${bannerName}-${userEmail}`,
    "",
    "local",
  );

  const actualDate = useMemo((): Date => new Date(), []);

  useEffect((): void => {
    if (bannerClosedDate === null) {
      setStoredDate(actualDate.toISOString());
    } else {
      const storedDate = new Date(bannerClosedDate);

      if (
        storedDate.getDate() !== actualDate.getDate() ||
        storedDate.getMonth() !== actualDate.getMonth() ||
        storedDate.getFullYear() !== actualDate.getFullYear()
      ) {
        setStoredDate(actualDate.toISOString());
        bannerStorage.removeItem(`closed-${userEmail}`);
      }
    }
  }, [bannerClosedDate, actualDate, setStoredDate, userEmail]);

  if (bannerClosedDate === null) {
    return true;
  }

  const storedDate = new Date(bannerClosedDate);

  return (
    storedDate.getDate() !== actualDate.getDate() ||
    storedDate.getMonth() !== actualDate.getMonth() ||
    storedDate.getFullYear() !== actualDate.getFullYear()
  );
};

export { useDailyBanner };
